import axios from 'axios';
import DoApi from './utils/DoApi';
// 创建第一个axios实例并配置拦截器
const axiosInstance = axios.create({
    baseURL: 'https://jm.lezhireading.com/api/open',
    timeout: 20000,
});
axiosInstance.interceptors.request.use(
    config => {
        // let token = Cookies.get('token')
        config.data = JSON.stringify(config.data);

        if (
            config.headers["Content-Type"] !=
            "application/x-www-form-urlencoded;charset:UTF-8"
        ) {
            config.headers["Content-Type"] = "application/json;charset=UTF-8";
        }
        const token = sessionStorage.token;
        if ((config.url.indexOf("yun") != -1 || config.url.indexOf("/s/") != -1) && token) {
            config.headers['Authorization'] = 'Bearer ' + token
        } else {
            config.headers['Authorization'] = ''
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
axiosInstance.interceptors.response.use(
    response => {
        // console.log('拦截器1:',response)
        return response.data;
    },
    error => {
        return Promise.reject(error)
    }
);
// 创建第二个axios实例并配置拦截器
const axiosInstance2 = axios.create({
    // baseURL: 'https://wstestv2.lezhireading.com:30443/api',
    baseURL: 'https://yun.cnuen.net/api',
    timeout: 20000
});
axiosInstance2.interceptors.request.use(
    config => {
        // let token = Cookies.get('token')
        config.data = JSON.stringify(config.data);

        if (
            config.headers["Content-Type"] !=
            "application/x-www-form-urlencoded;charset:UTF-8"
        ) {
            config.headers["Content-Type"] = "application/json;charset=UTF-8";
        }
        const token = sessionStorage.getItem('token');
        config.headers['Authorization'] = 'Bearer ' + token;
        config.headers["x-role"] = 100;
        // console.log('token---:', token)
        // if ((config.url.indexOf("yun") != -1 || config.url.indexOf("/s/") != -1) && token) {
        //     console.log('添加token')
        //     config.headers['Authorization'] = 'Bearer ' + token
        // } else {
        //     console.log('删除token')
        //     config.headers['Authorization'] = ''
        // }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
axiosInstance2.interceptors.response.use(response => {
    // console.log('拦截器2:',response)
    return response.data;
},
    error => {
        return Promise.reject(error)
    });
// 创建第三个axios实例并配置拦截器
const axiosInstance3 = axios.create({
    baseURL: 'https://yunadmin.cnuen.net',
    timeout: 20000
});
axiosInstance3.interceptors.request.use(
    config => {
        // let token = Cookies.get('token')
        config.data = JSON.stringify(config.data);

        if (
            config.headers["Content-Type"] !=
            "application/x-www-form-urlencoded;charset:UTF-8"
        ) {
            config.headers["Content-Type"] = "application/json;charset=UTF-8";
        }
        const token = sessionStorage.token;
        if ((config.url.indexOf("yun") != -1 || config.url.indexOf("/s/") != -1) && token) {
            config.headers['Authorization'] = 'Bearer ' + token
        } else {
            config.headers['Authorization'] = ''
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
axiosInstance3.interceptors.response.use(response => {
    // console.log('拦截器2:',response)
    return response.data;
},
    error => {
        return Promise.reject(error)
    });
// api装饰器
function send(target, name, descriptor, callback) {
    descriptor.value = function () {
        return callback(arguments[0]);
    };
    return descriptor;
}
// 添加 路径
function url(url) {
    return function (target, name, descriptor) {
        descriptor.url = url;
    }
}
function get(target, name, descriptor) {
    return send(target, name, descriptor, function (args, url) {
        return axiosInstance.get(descriptor.url + '?' + DoApi.jsonUrlFormat(args));
    });
}
function get2(target, name, descriptor) {
    return send(target, name, descriptor, function (args, url) {
        return axiosInstance2.get(descriptor.url + '?' + DoApi.jsonUrlFormat(args));
    });
}
function get3(target, name, descriptor) {
    return send(target, name, descriptor, function (args, url) {
        return axiosInstance3.get(descriptor.url + '?' + DoApi.jsonUrlFormat(args));
    });
}
function post(target, name, descriptor) {
    return send(target, name, descriptor, function (args) {
        return axiosInstance.post(descriptor.url + '?' + DoApi.jsonUrlFormat({}), DoApi.doJson(args));
    });
}
function post2(target, name, descriptor) {
    return send(target, name, descriptor, function (args) {
        return axiosInstance2.post(descriptor.url + '?' + DoApi.jsonUrlFormat({}), DoApi.doJson(args));
    });
}
function fetch(target, name, descriptor) {
    return send(target, name, descriptor, function (args) {
        return axiosInstance.get(descriptor.url + args);
    });
}
function fetch2(target, name, descriptor) {
    return send(target, name, descriptor, function (args) {
        return axiosInstance2.get(descriptor.url + args);
    });
}
function put2(target, name, descriptor) {
    return send(target, name, descriptor, function (args) {
      return axiosInstance2.put(descriptor.url + '?' + DoApi.jsonUrlFormat({}), DoApi.doJson(args));
    });
  }

export {
    get,
    get2,
    url,
    post,
    post2,
    fetch,
    fetch2,
    get3,
    put2
}